import { render } from "./view-reccomendation.vue?vue&type=template&id=ed2f8b56&lang=html"
import script from "./view-reccomendation.vue?vue&type=script&lang=js"
export * from "./view-reccomendation.vue?vue&type=script&lang=js"

import "./view-reccomendation.vue?vue&type=style&index=0&id=ed2f8b56&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__